// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_bp-2";
export var aiChatCartContainerExit = "_bp-4";
export var aiChatContainerLarge = "_bp-0";
export var aiChatContainerSmall = "_bp-1";
export var aiChatIcon = "_bp-6";
export var slideInFromRight = "_bp-3";
export var slideOutToRight = "_bp-5";